
export default function Footer(){
    return (
        <footer className='footer'>
            <p>IDLab, Ghent University</p>
        </footer>
    )
}